import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-description-producer',
  templateUrl: './description-producer.component.html',
  styleUrls: ['./description-producer.component.scss'],
})
export class DescriptionProducerComponent {
  isQuestionnaireVisible: any;
  @Input() data: any;
  @Output() saveEmitter = new EventEmitter();
  @Output() questionnaireDisplayEmitter = new EventEmitter();
  isEditMode = false;

  save() {
    this.isEditMode = false;
    this.saveEmitter.emit(this.data);
  }

  showQuestionnaire() {
    this.questionnaireDisplayEmitter.emit();
  }
}
